module.exports = __webpack_public_path__ + "img/11.8f391391.jpg";